module.exports = __webpack_public_path__ + "8b7de5b72cb2ae1daf3147a9dd05bddc.pdf";